// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0c4a158","59":"a3c854b2","73":"d364058c","110":"a5524a71","179":"39ffdd42","329":"ce699ebc","389":"e1e1069c","441":"2f662947","479":"9bc10f91","497":"a9c000dc","614":"439e042a","631":"db14e44a","871":"79614081","983":"5550e68c"}[chunkId] + ".chunk.js";
};